/* Global site behaviours: sticky header, mobile nav, language selector, scroll-reveal. */
(function () {
  "use strict";

  /* Sticky header shadow on scroll */
  var header = document.querySelector("[data-site-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Mobile nav drawer */
  var mobileNav = document.querySelector("[data-mobile-nav]");
  var mobileNavToggles = document.querySelectorAll("[data-mobile-nav-toggle]");
  var mobileNavClose = document.querySelectorAll("[data-mobile-nav-close]");
  function toggleMobileNav(open) {
    if (!mobileNav) return;
    mobileNav.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      var firstLink = mobileNav.querySelector("a, button");
      if (firstLink) firstLink.focus();
    }
  }
  mobileNavToggles.forEach(function (btn) {
    btn.addEventListener("click", function () { toggleMobileNav(true); });
  });
  mobileNavClose.forEach(function (btn) {
    btn.addEventListener("click", function () { toggleMobileNav(false); });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") toggleMobileNav(false);
  });

  /* Language / market selector dropdown */
  document.querySelectorAll("[data-lang-selector]").forEach(function (root) {
    var trigger = root.querySelector("[data-lang-trigger]");
    if (!trigger) return;
    trigger.addEventListener("click", function (e) {
      e.stopPropagation();
      root.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", root.classList.contains("is-open"));
    });
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) {
        root.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
      }
    });
    root.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        root.classList.remove("is-open");
        trigger.focus();
      }
    });
  });

  /* Scroll-reveal animations */
  var animated = document.querySelectorAll("[data-animate]");
  if (animated.length) {
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-in");
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
      );
      animated.forEach(function (el) { io.observe(el); });
    } else {
      animated.forEach(function (el) { el.classList.add("is-in"); });
    }
  }

  /* Newsletter form (Shopify customer form) async submit with inline feedback */
  document.querySelectorAll(".newsletter-form-el").forEach(function (form) {
    var status = form.querySelector("[data-form-status]");
    form.addEventListener("submit", function () {
      if (!status) return;
      window.setTimeout(function () {
        var hasError = window.location.search.indexOf("customer_posted=false") !== -1 ||
          form.querySelector(".errors");
        status.hidden = false;
        status.dataset.state = hasError ? "error" : "success";
        status.textContent = hasError
          ? status.dataset.errorText
          : status.dataset.successText;
      }, 0);
    });
  });
})();
